export const SUPER_ADMIN = "Super Admin";
export const ADMIN = "Sysadmin";
export const INSURANCE = "Insurance";
export const BANK = "Bank Pusat";
export const BROKER = "Broker";
export const BANK_PUSAT = "Bank Pusat";
export const BANK_CABANG = "Bank Cabang";
export const ADMIN_REASURANSI = "Sysadmin Reasuransi";
export const REASURANSI = "Reasuransi";
export const USER_REINSURANCE = "USER_REINSURANCE";
// Lembaga keuangan tunggal (tanpa pemisahan pusat/cabang), mengikuti fe-cnaf
export const LEMBAGA_KEUANGAN = "Bank";
